import type { RouteRecordRaw } from 'vue-router'

const rolesRoutes: RouteRecordRaw[] = [
  {
    path: '/settings/roles',
    name: 'roles.index',
    component: () => import('@/modules/user/role/views/RolesIndex.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumbs: ['Roles']
    }
  },
  {
    path: '/settings/roles/:id/show',
    name: 'roles.show',
    component: () => import('@/modules/user/role/views/RoleShow.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumbs: ['Roles']
    }
  },
  {
    path: '/settings/roles/create',
    name: 'roles.create',
    component: () => import('@/modules/user/role/views/RoleEdit.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumbs: ['Roles']
    }
  },
  {
    path: '/settings/roles/:id/edit',
    name: 'roles.edit',
    component: () => import('@/modules/user/role/views/RoleEdit.vue'),
    meta: {
      pageTitle: 'Roles',
      breadcrumbs: ['Roles']
    }
  }
]

export default rolesRoutes
